import React from 'react';
import { st, classes } from './SkeletonLine.st.css';
import { DEFAULT_WIDTH, HEIGHT } from './constants';
import { DEFAULT_SKIN } from '../SkeletonGroup/SkeletonGroup.constants';
import { Box } from '../Box';
import { SkeletonGroupContext } from '../SkeletonGroup';
import { SkeletonLineProps } from './SkeletonLine.types';

const SkeletonLine = ({
  dataHook,
  className,
  width = DEFAULT_WIDTH,
  margin,
  marginLeft,
  marginRight,
  marginTop,
  marginBottom,
}: SkeletonLineProps) => {
  return (
    <SkeletonGroupContext.Consumer>
      {context => {
        const skin = (context && context.skin) || DEFAULT_SKIN;
        return (
          <div
            data-hook={dataHook}
            className={className}
            data-width={width}
            data-skin={skin}
          >
            <Box
              height={HEIGHT}
              width={width}
              margin={margin}
              marginLeft={marginLeft}
              marginRight={marginRight}
              marginTop={marginTop}
              marginBottom={marginBottom}
              className={st(classes.root, { skin })}
            />
          </div>
        );
      }}
    </SkeletonGroupContext.Consumer>
  );
};

SkeletonLine.displayName = 'SkeletonLine';

export { SkeletonLine };
